import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { facesData } from './data';
import FacesDetails from './FacesDetails';
import { ContainerStyled, FacesStyled } from './style';

const Faces = () => {
  const theme = useTheme();
  return (
    <FacesStyled>
      <ContainerStyled>
        <div className="main-text">
          <Typography
            style={{ color: theme.colors.landingSecondaryText }}
            className="heading"
          >
            Meet the faces behind Escape Plan
          </Typography>
          <Typography fontColor="dark">
            People who made us successful
          </Typography>
        </div>

        <div className="faces">
          {facesData.map((face, idx) => (
            <FacesDetails
              key={idx}
              desc={face.desc}
              img={face.img}
              name={face.name}
              position={face.position}
            />
          ))}
        </div>
      </ContainerStyled>
    </FacesStyled>
  );
};

export default Faces;
